import { AngularFireUploadTask } from '@angular/fire/compat/storage';
import { UploadTaskSnapshot } from '@angular/fire/compat/storage/interfaces';
import { catchError, EMPTY, lastValueFrom, Observable } from 'rxjs';

import ValueObject from '../../../core/domain/value_object';
import { MessageAttachmentHelpProps } from './message-help';

interface AttachmentUploadProps {
  attachment: MessageAttachmentHelpProps;
  task: AngularFireUploadTask;
}

export class AttachmentUpload extends ValueObject<AttachmentUploadProps> {
  get attachment(): MessageAttachmentHelpProps {
    return this.props.attachment;
  }

  get task(): AngularFireUploadTask {
    return this.props.task;
  }

  get progress(): Observable<number | undefined> {
    return this.task.percentageChanges().pipe(
      catchError(() => {
        return EMPTY;
      }),
    );
  }

  get changes(): Observable<UploadTaskSnapshot | undefined> {
    return this.task.snapshotChanges();
  }

  cancel(): boolean {
    if (this.task.task.snapshot.state == 'canceled') return true;
    return this.task.cancel();
  }

  async getUrl(): Promise<string> {
    await lastValueFrom(this.changes);
    return this.task.task.snapshot.ref.getDownloadURL();
  }

  private constructor(props: AttachmentUploadProps) {
    super(props);
  }

  public static create(props: AttachmentUploadProps): AttachmentUpload {
    return new AttachmentUpload(props);
  }
}
